<template>
  <div v-loading="projectInstanceListLoading" class="custom-container">
    <div v-if="customList === null || customList.length === 0" class="no-data">
      <el-empty :description="$t('customCluster.customList.noClusterInfo')">
        <el-button type="text" @click="checkProjectTencentAccountExist">{{
            $t('customCluster.customList.createNow')
          }}
        </el-button>
      </el-empty>

      <!--   录入aksk并保存   -->
      <ExamineAKSK :examineAKSKVisible="examineAKSKVisible" :examineAKSKVisibleFalse="examineAKSKVisibleFalse"/>
    </div>
    <!--  自定义集群  -->
    <div v-else class="custom-table__content">
      <el-button class="base-margin__bottom-20" type="primary" @click="createClusterDialog('create')">
        {{ $t('customCluster.customList.createSubCluster') }}
      </el-button>
      <el-button
        :disabled="multipleSelection.length === 0"
        class="base-margin__bottom-20"
        @click="exportToExcel('batch')"
      >
        {{ $t('customCluster.customList.batchExport') }}
      </el-button>
      <el-button class="base-margin__bottom-20" @click="openAlarmPoliciesDialog">
        {{ $t('customCluster.customList.alarmPolicies') }}
      </el-button>
      <el-button class="base-margin__bottom-20" @click="openBatchAddInstanceDialog">
        {{ $t('customCluster.customList.batchAddInstance') }}
      </el-button>
      <!-- 表格 -->
      <el-table :data="customList" class="custom-table" @selection-change="handleSelectionChange">
        <el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
        <el-table-column :label="$t('customCluster.customList.idName')" width="260px">
          <template slot-scope="scope">
            <p class="base-color__light_blue base-cursor__pointer" @click="toDetail(scope.row)">{{ scope.row.id }}</p>
            <p @mouseenter="showId = scope.row.id" @mouseleave="showId = 0">
              {{ scope.row.name }}
              <el-button
                v-show="showId === scope.row.id"
                class="el-icon-edit"
                type="text"
                @click="showRenameDialog(scope.row)"
              ></el-button>
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.customList.instanceType')" min-width="110px"
                         prop="instance_type"></el-table-column>
        <el-table-column :label="$t('customCluster.customList.runningAvailable')" min-width="115px">
          <template slot-scope="scope">
            {{ scope.row.instance_num === -1 ? '-' : scope.row.instance_num }} / {{ scope.row.ip_sum }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.customList.regionZone')" min-width="100px">
          <template slot-scope="scope">
            {{ regionNameMap.get(scope.row.region) }} - {{ zoneName(scope.row) }}
          </template>
        </el-table-column>
        <!--        <el-table-column prop="zone" label="可用区" width="80px">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ zoneName(scope.row) }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column :label="$t('customCluster.customList.image')" min-width="98px"
                         prop="image_id"></el-table-column>
        <!--        <el-table-column prop="ip_sum" label="运行 / 可用范围"></el-table-column>-->
        <el-table-column :label="$t('customCluster.customList.vpc')" min-width="98px">
          <template slot-scope="scope">
            <p class="base-color__light_blue base-cursor__pointer" @click="open('vpc', scope.row)">
              {{ scope.row.vpc_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.customList.subnet')" min-width="116px">
          <template slot-scope="scope">
            <p class="base-color__light_blue base-cursor__pointer" @click="open('subnet', scope.row)">
              {{ scope.row.subnet_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customCluster.customList.createTime')" min-width="134px"
                         prop="create_time"></el-table-column>
        <el-table-column :label="$t('customCluster.customList.actions')" min-width="200px">
          <template slot-scope="scope">
            <el-button type="text" @click="editCluster('edit', scope.row.id)">{{
                $t('customCluster.customList.edit')
              }}
            </el-button>
            <el-button type="text" @click="showAddInstanceDialog(scope.row.id)">{{
                $t('customCluster.customList.addInstance')
              }}
            </el-button>
            <el-button type="text" @click="toMonitor(scope.row)">{{
                $t('customCluster.customList.monitor')
              }}
            </el-button>
            <el-dropdown class="base-margin__left-8">
              <span class="el-dropdown-link">
                <el-button type="text">{{ $t('customCluster.customList.more') }}</el-button>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <p class="base-cursor__pointer" @click="editCluster('copy', scope.row.id)">
                    {{ $t('customCluster.customList.copy') }}</p>
                </el-dropdown-item>
                <el-dropdown-item>
                  <p class="base-cursor__pointer" @click="setSubclusterInitCommandShow(scope.row)">
                    {{ $t('customCluster.customList.initScript') }}</p>
                </el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.instance_num > 0">
                  <p class="base-cursor__pointer" @click="setTopology(scope.row.id, scope.row.topology)">
                    {{
                      scope.row.topology ? $t('customCluster.customList.disableHyperThreading') : $t('customCluster.customList.enableHyperThreading')
                    }}
                  </p>
                </el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.instance_num > 0">
                  <p class="base-cursor__pointer" @click="deleteSubcluster(scope.row.id)">
                    {{ $t('customCluster.customList.delete') }}</p>
                </el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.instance_num === 0">
                  <p class="base-cursor__pointer" @click="openExportDialog(scope.row)">
                    {{ $t('customCluster.customList.export') }}</p>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!--  改名弹窗  -->
    <el-dialog :close-on-click-modal="false" :title="$t('customCluster.customList.rename')"
               :visible.sync="renameVisible" width="400px">
      <div class="base-flex">
        <span class="white-norwrap base-margin__right-20">{{ $t('customCluster.customList.newSubClusterName') }}</span>
        <el-input ref="editInput" v-model="clusterName" class="edit-name_input" maxlength="32"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renameVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button type="primary" @click="modify">{{ $t('customCluster.customList.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--  初始化脚本  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.customList.initScript')"
      :visible.sync="subclusterInitCommandVisible"
      width="1200px"
    >
      <div class="base-flex">
        <el-input
          v-model="subclusterInit"
          :placeholder="$t('customCluster.customList.initScriptPlaceholder')"
          :rows="20"
          type="textarea"
        >
        </el-input>

        <div class="base-margin__left-8">
          <el-input
            v-model="userdataTemplateValue"
            :placeholder="$t('customCluster.customList.searchPlaceholder')"
            class="base-margin__bottom-5"
            clearable
            @input="inputUserdata"
          >
          </el-input>
          <div class="userDataTemplate-cls">
            <div
              v-for="(item, index) in userdataTemplateList"
              :key="index"
              class="base-flex__between"
              @click="spliceSubclusterInit(item)"
            >
              <div>
                <i class="el-icon-tickets"/> <span>{{ item.name }}</span>
              </div>
              <el-tooltip :content="item.tips" class="item" effect="dark" placement="left-start">
                <div><i class="el-icon-warning-outline"/></div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <p class="base-margin__top-5">
        <el-checkbox v-model="base64Radio">{{ $t('customCluster.customList.base64Encoded') }}</el-checkbox>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="subclusterInitCommandVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button
          :disabled="subclusterInit.length === 0"
          type="primary"
          @click="subclusterInitCommandModify">
          {{ $t('customCluster.customList.confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!--  子集群创建、子集群编辑  -->
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :title="this.editClusterInfo ? $t('customCluster.customList.editSubCluster') : $t('customCluster.customList.createSubCluster')"
      :visible.sync="dialogClusterVisible"
      width="700px"
      @close="clearFromData"
    >
      <createCluster
        ref="createCluster"
        :checkPrice="checkPrice"
        :closeDialog="closeDialog"
        :getSubclusterList="getSubclusterList"
        :openPwDialog="openPwDialog"
        @doneFillIp="doneFillIp"
        @hostRangeListFormEmit="hostRangeListFormEmit"
      >
      </createCluster>
      <!--      预览ip-->
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('customCluster.customList.previewIp')"
        :visible.sync="previewDialogVisible"
        append-to-body
        width="600px"
      >
        <div class="previewDialog_main--div">
          <el-table :data="previewList" class="base-width_fullscreen" height="500">
            <el-table-column :label="$t('customCluster.customList.hostname')" prop="hostname"></el-table-column>
            <el-table-column label="ip" prop="ip"></el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="exportPreviewIp(previewList)">{{
              $t('customCluster.customList.export')
            }}</el-button>
        </span>
      </el-dialog>
      <template #footer>
        <div
          v-if="!editClusterInfo && !projectPriceBlacklist.includes(projectId.toString())"
          class="base-display__inline-block"
        >
          <span class="create-price__span"><span>{{ $t('customCluster.customList.estimatedCost') }}</span></span>
          <span v-if="!createLoading" class="base-color__orange">{{ unitPriceDiscount }}</span>
          <i v-else class="el-icon-loading base-color__orange"></i>
          <span class="base-margin__right-10">{{
              instanceChargeType === 'POSTPAID_BY_HOUR' ? $t('customCluster.customList.yuanPerHour') : $t('customCluster.customList.yuanPerMonth')
            }}</span>
          <span class="unitPrice_cls">
            <span v-if="!createLoading">{{ unitPrice }}</span>
            <i v-else class="el-icon-loading"></i>
            {{
              instanceChargeType === 'POSTPAID_BY_HOUR' ? $t('customCluster.customList.yuanPerHour') : $t('customCluster.customList.yuanPerMonth')
            }}
          </span>
        </div>
        <el-button @click="clearFromData()">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button v-if="!isEditCluster && stepLocation > 0" :loading="createLoading" @click="stepLocationIndex(false)">
          {{ $t('customCluster.customList.previous') }}
        </el-button>
        <el-button
          v-if="!isEditCluster && stepLocation < 3"
          :disabled="unitPriceDiscount === '-' && !editClusterInfo || (stepLocation === 1 && hostRangeListForm.length === 0)"
          :loading="createLoading"
          type="primary"
          @click="stepLocationIndex(true)"
        >{{ $t('customCluster.customList.next') }}
        </el-button>
        <el-button v-if="stepLocation === 3" type="primary" @click="affirm">{{
            $t('customCluster.customList.complete')
          }}
        </el-button>
        <el-button v-if="isEditCluster" type="primary" @click="affirm">{{
            $t('customCluster.customList.complete')
          }}
        </el-button>
      </template>
    </el-dialog>

    <!--  子集群导出  -->
    <el-dialog :close-on-click-modal="false" :title="$t('customCluster.customList.export')"
               :visible.sync="exportDialogVisible" width="700px">
      <div>
        <el-radio-group v-model="radio" @input="checkRadio">
          <div class="base-margin__bottom-10">
            <el-radio :label="false">{{ $t('customCluster.customList.exportAll') }}</el-radio>
          </div>
          <div class="base-flex base-height__30">
            <el-radio :label="true" class="base-margin__top-10">{{
                $t('customCluster.customList.exportByBatch')
              }}
            </el-radio>
            <span class="base-width__300">
              <!--   批次     -->
              <BatchIndex
                v-show="radio"
                ref="batchIndex"
                :subclusterId="Number(this.$route.query.id)"
                @filterSubclusterInstances="filterSubclusterInstances"
              />
            </span>
          </div>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button type="primary" @click="exportBatch()">{{ $t('customCluster.customList.confirm') }}</el-button>
      </span>
    </el-dialog>
    <!--  添加实例  -->
    <addInstanceDialog
      ref="addInstanceDialog"
      v-loading.fullscreen.lock="isCreating"
      :element-loading-text="$t('customCluster.customList.creatingInstance')"
      :getSubclusterList="getSubclusterList"
      :showLoading="showLoading"
      :subclusterId="subclusterId"
    />

    <!-- 输入初始化脚本 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.customList.inputInitScript')"
      :visible.sync="variableDialogFormVisible"
      width="600px"
    >
      <div>
        <div>
          <el-row class="variableTitle">
            <el-col :span="10">
              <div>{{ $t('customCluster.customList.name') }}</div>
            </el-col>
            <el-col :span="2">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="10">
              <div>{{ $t('customCluster.customList.value') }}</div>
            </el-col>
          </el-row>
        </div>
        <div v-for="(item, index) in defaultSpliceSubclusterData" :key="index" class="base-margin__top-10">
          <el-row>
            <el-col :span="10">
              <el-input v-model="item.variable" disabled></el-input>
            </el-col>
            <el-col :span="2">
              <div class="base-text-align__center base__line-height-30">=</div>
            </el-col>
            <el-col :span="10">
              <el-input v-model="item.value" :placeholder="item.placeholder"></el-input>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="variableDialogFormVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button type="primary" @click="doneSubclusterVariable">{{
            $t('customCluster.customList.confirm')
          }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 告警策略 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.customList.alarmPolicies')"
      :visible.sync="describeAlarmPoliciesVisible"
      width="900px"
    >
      <el-form ref="form" v-loading="describeAlarmPoliciesLoading" label-position="left">
        <el-form-item>
          <div v-for="(item, index) in alarmPoliciesForm" :key="index" class="base-flex base-margin__top-5">
            <div class="base-margin__right-10">{{ $t('customCluster.customList.alarmPolicy') }}</div>
            <el-select v-model="item.policyId" class="base-width__300 base-margin__right-20">
              <el-option
                v-for="(item, index) in describeAlarmPoliciesList"
                :key="index"
                :label="`${item.PolicyName} | ${item.Remark || '-'}`"
                :value="item.PolicyId"
              >
              </el-option>
            </el-select>
            <div class="base-margin__right-10">{{ $t('customCluster.customList.subCluster') }}</div>
            <el-select
              v-model="item.subclusterIds"
              class="base-width__300 base-margin__right-10"
              clearable
              collapse-tags
              multiple
            >
              <el-option v-for="(item, index) in customList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button
              v-if="item.deleteShow"
              class="base-margin__left-10"
              type="text"
              @click="deleteAlarmPolicies(index)"
            >{{ $t('customCluster.customList.delete') }}
            </el-button
            >
          </div>
          <el-button type="text" @click="addAlarmPoliciesNumber">{{
              $t('customCluster.customList.addPolicy')
            }}
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="describeAlarmPoliciesVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button :disabled="describeAlarmPoliciesLoading" @click="addAlarmPolicies">
          {{ $t('customCluster.customList.createPolicy') }}
        </el-button>
        <el-button
          :disabled="describeAlarmPoliciesLoading"
          :loading="doneDescribeAlarmPoliciesLoding"
          type="primary"
          @click="doneDescribeAlarmPolicies"
        >{{ $t('customCluster.customList.confirm') }}
        </el-button
        >
      </div>
    </el-dialog>

    <!-- 新增告警策略 -->
    <el-drawer
      :destroy-on-close="true"
      :visible.sync="alarmPoliciesDrawer"
      :with-header="false"
      :wrapperClosable="false"
      size="1200px"
      @closed="closeAlarmPoliciesDrawer('alarmPoliciesDrawer')"
    >
      <div class="base-padding__all-20">
        <el-form
          ref="alarmPoliciesDrawerForm"
          v-loading="alarmPoliciesDrawerFormLoading"
          :model="alarmPoliciesDrawerForm"
          :rules="alarmPoliciesDrawerRules"
          label-width="160px"
        >
          <div class="form-title base__font-weight_Bold">{{ $t('customCluster.customList.basicInfo') }}</div>
          <el-form-item :label="$t('customCluster.customList.policyName')" prop="policyName">
            <el-input
              v-model="alarmPoliciesDrawerForm.policyName"
              :placeholder="$t('customCluster.customList.max60Chars')"
              class="base-width__300"
              maxlength="60"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('customCluster.customList.remark')">
            <el-input
              v-model="alarmPoliciesDrawerForm.remark"
              :placeholder="$t('customCluster.customList.max100Chars')"
              :rows="5"
              class="base-width__300"
              maxlength="100"
              show-word-limit
              type="textarea"
            >
            </el-input>
          </el-form-item>

          <div class="form-title base__font-weight_Bold">{{ $t('customCluster.customList.configAlarmRules') }}</div>

          <el-form-item :label="$t('customCluster.customList.notificationTemplate')" prop="noticeIds">
            <el-select
              v-model="alarmPoliciesDrawerForm.noticeIds"
              :placeholder="$t('customCluster.customList.selectNotificationTemplate')"
              class="base-width__300"
              collapse-tags
              multiple
              size="mini"
            >
              <el-option
                v-for="(item, index) in describeAlarmNoticesList"
                :key="index"
                :label="`${item.Name} | ${item.Id}`"
                :value="item.Id"
              >
              </el-option>
            </el-select>
            <el-button class="base-margin__left-10" size="mini" type="primary" @click="createNotification"
            >{{ $t('customCluster.customList.addNotificationTemplate') }}
            </el-button
            >
          </el-form-item>

          <el-form-item :label="$t('customCluster.customList.subCluster')" prop="subclusterIds">
            <el-select
              v-model="alarmPoliciesDrawerForm.subclusterIds"
              :placeholder="$t('customCluster.customList.selectSubCluster')"
              class="base-width__300"
              collapse-tags
              multiple
              size="mini"
            >
              <el-option v-for="(item, index) in customList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="form-title">
            {{ $t('customCluster.customList.triggerWhen') }}
            <el-select class="base-width__100" size="mini" value="任意">
              <el-option :label="$t('customCluster.customList.any')" value="1"></el-option>
            </el-select>
            {{ $t('customCluster.customList.metricConditions') }}
          </div>

          <div v-for="(item, index) in conditionList" :key="index" class="form-title">
            if
            <el-select
              v-model="item.metricName"
              :disabled="true"
              class="base-width__170 base-margin__left-10"
              filterable
              size="mini"
            >
              <el-option
                v-for="(item, index) in describeBaseMetricsList"
                :key="index"
                :label="item.MetricCName"
                :value="item.MetricName"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item" content="" effect="dark" placement="top-start">
              <template slot="content">
                <div class="base-width__300 base-font-size__12px">
                  {{ item.metricText }}
                  <el-link v-if="item.metricTextLink" type="primary" @click="open('textLink', item.metricTextLink)"
                  >{{ $t('customCluster.customList.troubleshootingGuide') }}<i class="el-icon-share el-icon--right"></i>
                  </el-link>
                </div>
              </template>
              <i v-if="item.metricText" class="el-icon-warning-outline base-margin__left-10"/>
              <span v-else class="base-margin__left-24"></span>
            </el-tooltip>
            <el-select v-model="item.period" class="base-width__170 base-margin__left-10" size="mini">
              <el-option v-for="(item, index) in periodList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="item.operator" class="base-width__120 base-margin__left-10" size="mini">
              <el-option v-for="(item, index) in operatorList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <el-tooltip effect="dark" placement="top-start">
              <template slot="content">
                <div class="base-width__300 base-font-size__12px base-margin__left-10">
                  <ol start="1">
                    <li>{{ $t('customCluster.customList.staticThreshold') }}</li>
                    <li>{{ $t('customCluster.customList.staticThresholdRing') }}</li>
                    <li>
                      {{ $t('customCluster.customList.staticThresholdYoY') }}
                    </li>
                    <li>{{ $t('customCluster.customList.dynamicThreshold') }}</li>
                  </ol>
                  {{ $t('customCluster.customList.metricConditionDetails') }}
                  <el-link type="primary" @click="open('textLink', item.operatorLink)"
                  >{{ $t('customCluster.customList.alarmTriggerIntro') }}<i class="el-icon-share el-icon--right"></i>
                  </el-link>
                </div>
              </template>
              <i class="el-icon-warning-outline base-margin__left-10"/>
            </el-tooltip>
            <el-input-number
              v-model="item.value"
              :max="100"
              :min="1"
              class="base-margin__left-10"
              controls-position="right"
              size="mini"
            >
            </el-input-number>
            <el-select
              v-model="item.continuePeriod"
              class="base-width__170 base-margin__left-10"
              size="mini"
              value="持续5个数据点"
            >
              <el-option
                v-for="(item, index) in continuePeriodList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="base-margin__left-10">then</span>
            <el-select v-model="item.noticeFrequency" class="base-width__170 base-margin__left-10" size="mini">
              <el-option
                v-for="(item, index) in noticeFrequencyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item" content="Top Left 提示文字" effect="dark" placement="top-start">
              {{ $t('customCluster.customList.specifyFrequency') }}
              {{ $t('customCluster.customList.exponentialIncrease') }}
              <template slot="content">
                <div class="base-width__300 base-font-size__12px base-margin__left-10">
                  <ol start="1">
                    <li>
                      {{ $t('customCluster.customList.specifyFrequency') }}
                      <ul>
                        {{ $t('customCluster.customList.specifyFrequencyDesc') }}
                      </ul>
                    </li>
                    <li>
                      {{ $t('customCluster.customList.exponentialIncrease') }}
                      <ul>
                        {{ $t('customCluster.customList.exponentialIncreaseDesc') }}
                      </ul>
                    </li>
                  </ol>
                </div>
              </template>
              <i class="el-icon-warning-outline base-margin__left-10"/>
            </el-tooltip>
          </div>
          <el-form-item></el-form-item>
          <div class="form-title">
            <el-button type="primary" @click="submitAlarmPolicies">{{
                $t('customCluster.customList.createNow')
              }}
            </el-button>
            <el-button @click="alarmPoliciesDrawer = false">{{ $t('customCluster.customList.cancel') }}</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>

    <!-- 新增通知模板 -->
    <el-drawer
      :destroy-on-close="true"
      :visible.sync="createNotificationDrawer"
      :with-header="false"
      :wrapperClosable="false"
      size="940px"
      @closed="closeAlarmPoliciesDrawer('createNotificationDrawer')"
    >
      <div class="base-padding__all-20">
        <el-form
          ref="createNotificationDrawerForm"
          v-loading="createNotificationDrawerFormLoading"
          :model="createNotificationDrawerForm"
          :rules="createNotificationDrawerRules"
          label-width="160px"
        >
          <div class="form-title base__font-weight_Bold">{{ $t('customCluster.customList.basicInfo') }}</div>
          <el-form-item :label="$t('customCluster.customList.templateName')" prop="noticeName">
            <el-input
              v-model="createNotificationDrawerForm.noticeName"
              :placeholder="$t('customCluster.customList.max60Chars')"
              class="base-width__300"
              maxlength="60"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('customCluster.customList.notificationType')" prop="noticeTypeArr">
            <el-checkbox-group v-model="createNotificationDrawerForm.noticeTypeArr">
              <el-checkbox label="ALARM">{{ $t('customCluster.customList.alarmTrigger') }}</el-checkbox>
              <el-checkbox label="OK">{{ $t('customCluster.customList.alarmRecovery') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('customCluster.customList.notificationLanguage')" prop="language">
            <el-select v-model="createNotificationDrawerForm.language"
                       :placeholder="$t('customCluster.customList.selectLanguage')"
                       class="base-width__300">
              <el-option :label="$t('customCluster.customList.chinese')" value="zh"></el-option>
              <el-option :label="$t('customCluster.customList.english')" value="en"></el-option>
            </el-select>
          </el-form-item>

          <div class="form-title base__font-weight_Bold">{{ $t('customCluster.customList.notificationActions') }}</div>

          <el-form-item :label="$t('customCluster.customList.interfaceCallback')" label-width="160px">
            <div class="interfaceCallback_div_cls">
              <el-form-item :label="$t('customCluster.customList.selectCloudFunction')"
                            prop="noticeUrl">
                <!--<el-input class="base-font-size__12px" v-model="createNotificationDrawerForm.noticeUrl"
                placeholder="填写公网可访问到的url作为回调接口地址(域名或IP[:端口][/path])，例如https://example.com:8080/alarm/callback">-->
                <el-select
                  v-model="createNotificationDrawerForm.noticeUrl"
                  :placeholder="$t('customCluster.customList.selectInterfaceUrl')"
                  class="base-width__320"
                >
                  <el-option
                    v-for="(item, index) in functionInfoList"
                    :key="index"
                    :label="`${item.functionName} | ${item.functionId}`"
                    :value="item.callbackURL"
                  ></el-option>
                </el-select>
                <el-button class="base-margin__left-10" type="primary" @click="createScalingInSCF"
                >{{ $t('customCluster.customList.addCloudFunction') }}
                </el-button
                >
              </el-form-item>
              <el-form-item label=" ">
                <p class="base-font-size__12px base-margin__top-5">
                  {{ $t('customCluster.customList.interfaceCallbackDesc') }}
                  <el-link
                    :underline="false"
                    class="base-font-size__12px"
                    type="primary"
                    @click="open('textLink', 'https://cloud.tencent.com/document/product/248/50409')"
                  >{{ $t('customCluster.customList.viewGuide') }}<i class="el-icon-share el-icon--right"></i>
                  </el-link>
                </p>
              </el-form-item>
              <el-form-item :label="$t('customCluster.customList.notificationCycle')" prop="weekday">
                <el-checkbox-group v-model="createNotificationDrawerForm.weekday">
                  <el-checkbox :label="1">{{ $t('customCluster.customList.monday') }}</el-checkbox>
                  <el-checkbox :label="2">{{ $t('customCluster.customList.tuesday') }}</el-checkbox>
                  <el-checkbox :label="3">{{ $t('customCluster.customList.wednesday') }}</el-checkbox>
                  <el-checkbox :label="4">{{ $t('customCluster.customList.thursday') }}</el-checkbox>
                  <el-checkbox :label="5">{{ $t('customCluster.customList.friday') }}</el-checkbox>
                  <el-checkbox :label="6">{{ $t('customCluster.customList.saturday') }}</el-checkbox>
                  <el-checkbox :label="7">{{ $t('customCluster.customList.sunday') }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item :label="$t('customCluster.customList.notificationTime')" class="base-margin__top-20">
                <el-time-picker
                  v-model="createNotificationDrawerForm.pickerTime"
                  :placeholder="$t('customCluster.customList.selectTimeRange')"
                  end-placeholder="结束时间"
                  is-range
                  range-separator="至"
                  start-placeholder="开始时间"
                >
                </el-time-picker>
              </el-form-item>
            </div>
          </el-form-item>
          <div class="form-title">
            <el-button type="primary" @click="submitCreateNotification">{{
                $t('customCluster.customList.complete')
              }}
            </el-button>
            <el-button @click="createNotificationDrawer = false">{{ $t('customCluster.customList.cancel') }}</el-button>
          </div>
        </el-form>

        <!-- 新增云函数 -->
        <el-dialog
          :close-on-click-modal="false"
          :title="$t('customCluster.customList.addCloudFunction')"
          :visible.sync="createScalingInSCFVisible"
          append-to-body
          width="600px"
        >
          <el-form
            ref="createScalingInSCFForm"
            v-loading="createScalingInSCFInfoLoading"
            :model="createScalingInSCFInfo"
            :rules="createScalingInSCFInfoRules"
            label-width="130px"
          >
            <el-form-item :label="$t('customCluster.customList.functionName')" prop="roleName">
              <el-input
                v-model="createScalingInSCFInfo.roleName"
                :placeholder="$t('customCluster.customList.max60Chars')"
                maxlength="60"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('customCluster.customList.region')" prop="region">
              <el-select v-model="createScalingInSCFInfo.region"
                         :placeholder="$t('customCluster.customList.selectCloudFunctionRegion')">
                <el-option v-for="item in regionData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('customCluster.customList.scheduler')" prop="workloadManager">
              <el-select v-model="createScalingInSCFInfo.workloadManager"
                         :placeholder="$t('customCluster.customList.selectScheduler')">
                <el-option label="slurm" value="slurm"></el-option>
                <el-option label="LSF" value="lsf"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeCreateScalingInSCF">{{ $t('customCluster.customList.cancel') }}</el-button>
            <el-button type="primary" @click="submitCreateScalingInSCF">{{
                $t('customCluster.customList.complete')
              }}</el-button>
          </span>
        </el-dialog>
      </div>
    </el-drawer>

    <!-- 批量添加实例 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.customList.batchAddInstance')"
      :visible.sync="batchAddInstanceDialogVisible"
      width="700px"
    >
      <div class="batch-add-instance-container">
        <div class="batch-add-header">
          <div class="header-item subcluster-name">{{ $t('customCluster.customList.subClusterName') }}</div>
          <div class="header-item instance-type">{{ $t('customCluster.customList.instanceType') }}</div>
          <div class="header-item quantity">{{ $t('customCluster.customList.selectQuantity') }}</div>
          <div class="header-item status">{{ $t('customCluster.customList.status') }}</div>
          <div class="header-item operation">{{ $t('customCluster.customList.operation') }}</div>
        </div>

        <div class="batch-add-list">
          <div
            v-for="(item, index) in batchAddInstanceCustomList"
            :key="item.id"
            class="batch-add-item"
          >
            <div class="item-content subcluster-name">{{ item.name }}</div>
            <div class="item-content instance-type">{{ item.instance_type || '-' }}</div>
            <div class="item-content quantity">
              <el-input-number
                v-model="quantityArray[index]"
                :min="0"
                :max="100"
                :placeholder="$t('customCluster.customList.inputQuantity')"
                size="small"
              />
            </div>
            <div class="item-content status">
              <i v-if="statusArray[index].status === 'loading'" class="el-icon-loading loading-icon"></i>
              <i v-if="statusArray[index].status === true" class="el-icon-circle-check success-icon"></i>
              <el-tooltip class="item" effect="dark" v-if="statusArray[index].status === false" :content="statusArray[index].message" placement="top-start">
                <i class="el-icon-warning-outline error-icon"></i>
              </el-tooltip>
                <span v-if="statusArray[index].status === null">-</span>
            </div>
            <div class="item-content operation">
              <el-button
                type="primary"
                size="small"
                @click="previewSubclusterIp(item)"
              >
                {{ $t('customCluster.customList.queryIp') }}
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="batchAddInstanceCustomList.length === 0" class="empty-tip">
          {{ $t('customCluster.customList.noSubclusterAvailable') }}
        </div>
      </div>
      <div>
        <div class="base-margin__bottom-20 base-margin__top-20">
          <span class="base-margin__right-20">{{ $t('customCluster.addInstanceDialog.passwordType') }}</span>
          <el-radio-group v-model="passwordRadio" @input="checkPasswordRadio">
            <el-radio :label="true">
              {{ $t('customCluster.addInstanceDialog.keepImageSetting') }}
            </el-radio>
            <el-radio :label="false">{{ $t('customCluster.addInstanceDialog.customPassword') }}</el-radio>
          </el-radio-group>
        </div>
        <div v-if="!isKeepImage">
          <div class="base-margin__bottom-20">
          <span class="base-margin__right-32" style="margin-right: 46px">
            {{ $t('customCluster.addInstanceDialog.password') }}
            <el-popover placement="top-start" trigger="hover" width="290">
              <div class="tips">
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule1') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule2') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule3') }}</p>
                <p>{{ $t('customCluster.addInstanceDialog.passwordRule4') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule5') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule6') }}</p>
                <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule7') }}</p>
                <p class="base-margin__left-20" v-text="'()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'"></p>
              </div>
              <el-icon slot="reference" class="el-icon-question">{{
                  $t('customCluster.addInstanceDialog.hoverActivate')
                }}</el-icon>
            </el-popover>
          </span>
            <el-input
              v-model="batchAddInstancePassword"
              :placeholder="$t('customCluster.addInstanceDialog.pleaseEnterPassword')"
              class="base-width__240"
              show-password
              type="password"
            ></el-input>
          </div>
          <div class="base-margin__bottom-20">
            <span class="base-margin__right-32"> {{ $t('customCluster.addInstanceDialog.confirmPassword') }} </span>
            <el-input
              v-model="batchAddInstanceNextPassword"
              :placeholder="$t('customCluster.addInstanceDialog.pleaseConfirmPassword')"
              class="base-width__240"
              show-password
              type="password"
            ></el-input>
          </div>
        </div>
        <!--<div class="base-margin__bottom-10">-->
        <!--  <span class="base-margin__right-32" style="margin-right: 46px">-->
        <!--    {{ $t('customCluster.addInstanceDialog.password') }}-->
        <!--    <el-popover placement="top-start" trigger="hover" width="290">-->
        <!--      <div class="tips">-->
        <!--        <p>{{ $t('customCluster.addInstanceDialog.passwordRule1') }}</p>-->
        <!--        <p>{{ $t('customCluster.addInstanceDialog.passwordRule2') }}</p>-->
        <!--        <p>{{ $t('customCluster.addInstanceDialog.passwordRule3') }}</p>-->
        <!--        <p>{{ $t('customCluster.addInstanceDialog.passwordRule4') }}</p>-->
        <!--        <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule5') }}</p>-->
        <!--        <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule6') }}</p>-->
        <!--        <p class="base-margin__left-20">{{ $t('customCluster.addInstanceDialog.passwordRule7') }}</p>-->
        <!--        <p class="base-margin__left-20" v-text="'()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'"></p>-->
        <!--      </div>-->
        <!--      <el-icon slot="reference" class="el-icon-question">{{-->
        <!--          $t('customCluster.addInstanceDialog.hoverActivate')-->
        <!--        }}</el-icon>-->
        <!--    </el-popover>-->
        <!--  </span>-->
        <!--  <el-input-->
        <!--    v-model="batchAddInstancePassword"-->
        <!--    :placeholder="$t('customCluster.addInstanceDialog.pleaseEnterPassword')"-->
        <!--    class="base-width__240"-->
        <!--    show-password-->
        <!--    type="password"-->
        <!--  ></el-input>-->
        <!--</div>-->
        <!--<div class="base-margin__bottom-20">-->
        <!--  <span class="base-margin__right-32"> {{ $t('customCluster.addInstanceDialog.confirmPassword') }} </span>-->
        <!--  <el-input-->
        <!--    v-model="batchAddInstanceNextPassword"-->
        <!--    :placeholder="$t('customCluster.addInstanceDialog.pleaseConfirmPassword')"-->
        <!--    class="base-width__240"-->
        <!--    show-password-->
        <!--    type="password"-->
        <!--  ></el-input>-->
        <!--</div>-->
      </div>

      <!-- IP预览对话框 -->
      <el-dialog
        :close-on-click-modal="false"
        :title="`${$t('customCluster.customList.queryIp')} ( ${batchPreviewList.length} )`"
        :visible.sync="batchPreviewDialogVisible"
        :z-index="9999"
        append-to-body
        width="500px"
      >
        <div class="batch-preview-dialog">
          <el-table
            :data="batchPreviewList"
            style="width: 100%"
          >
            <el-table-column :label="$t('customCluster.customList.hostname')" prop="hostname" width="180"></el-table-column>
            <el-table-column :label="$t('customCluster.customList.ip')" prop="ip" width="180"></el-table-column>
          </el-table>
        </div>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button @click="batchAddInstanceDialogVisible = false">{{ $t('customCluster.customList.cancel') }}</el-button>
        <el-button :loading="batchAddInstanceLoading" @click="submitBatchAddInstance('examine')">
            {{ $t('customCluster.addInstanceDialog.validateParams') }}
          </el-button>
        <el-button :loading="batchAddInstanceLoading" type="primary" @click="submitBatchAddInstance(('create'))">
          {{ $t('common.confirmSubmit') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import createCluster from '@/views/customCluster/components/createCluster';
import { mapGetters, mapState } from 'vuex';
import { extraPostRequest, getRequest, postRequest } from '@/common/libs/request';
import addInstanceDialog from '@/views/customCluster/customDetail/addInstanceDialog';
import { regionMap, regionNameMap } from '@/common/constants';
import ExamineAKSK from '@/components/examineAKSK/index.vue';
import BatchIndex from '@/components/batchIndex/index.vue';
import { exportData, regionList } from '@/common/utils/utils';
import { Base64 } from 'js-base64';
import {
  continuePeriodList,
  defalutConditionList,
  noticeFrequencyList,
  operatorList,
  periodList,
} from '@/views/customCluster/customList/conditionCommon';
import dayjs from 'dayjs';
import { Message } from 'element-ui';

export default {
  name: 'customList',
  data() {
    return {
      nextFillIpDisabled: true,
      stepLocation: 0,
      radio: false,
      info: '',
      dialogClusterVisible: false,
      previewDialogVisible: false,
      previewList: [],
      customList: [],
      total: 0,
      projectId: 0,
      currentPage: 1,
      limit: 10,
      subclusterId: 0,
      regionNameMap,
      isCreating: false,
      multipleSelection: [],
      unitPriceDiscount: '-',
      unitPrice: '-',
      showId: 0,
      renameVisible: false,
      clusterName: '',
      oldClusterName: '',
      currentRowId: 0,
      options: [],
      exportDialogVisible: false,
      batchIndex: [],
      exportId: '',
      editClusterInfo: false,
      examineAKSKVisible: false,
      currentProject: null,
      projectInstanceListLoading: false,
      loginType: sessionStorage.getItem('loginType'),
      createLoading: false,
      subclusterInitCommandVisible: false,
      subclusterInit: '',
      base64Radio: false,
      userdataTemplateList: [],
      defaultUserdataTemplateList: [],
      userdataTemplateValue: '',
      subclusterName: '',
      systemVariable: {},
      variableDialogFormVisible: false,
      defaultSpliceSubclusterData: {},
      subclusterInitValue: '',
      instanceChargeType: 'POSTPAID_BY_HOUR',
      describeAlarmPoliciesVisible: false,
      describeAlarmPoliciesList: [],
      describeAlarmPoliciesLoading: false,
      doneDescribeAlarmPoliciesLoding: false,
      alarmPoliciesForm: [
        {
          policyId: '',
          deleteShow: true,
          subclusterIds: [],
        },
      ],
      alarmPoliciesDrawer: false,
      stepsActive: 1,
      alarmPoliciesDrawerForm: {
        policyName: '',
        remark: '',
        noticeIds: [],
        subclusterIds: [],
      },
      alarmPoliciesDrawerRules: {
        policyName: [{
          required: true,
          message: this.$t('customCluster.customList.policyNameRequired'),
          trigger: 'blur',
        }],
        noticeIds: [{
          required: true,
          message: this.$t('customCluster.customList.noticeTemplateRequired'),
          trigger: 'change',
        }],
        subclusterIds: [{
          required: true,
          message: this.$t('customCluster.customList.subClusterRequired'),
          trigger: 'change',
        }],
      },
      describeBaseMetricsList: [],
      describeAlarmNoticesList: [],
      periodList,
      operatorList,
      continuePeriodList,
      noticeFrequencyList,
      conditionList: JSON.parse(JSON.stringify(defalutConditionList)),
      alarmPoliciesDrawerFormLoading: false,
      createNotificationDrawer: false,
      createNotificationDrawerFormLoading: false,
      createNotificationDrawerForm: {
        noticeName: '',
        noticeTypeArr: [],
        language: 'zh',
        noticeUrl: '',
        weekday: [],
        pickerTime: [
          new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
          new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59, 999),
        ],
      },
      createNotificationDrawerRules: {
        noticeName: [{
          required: true,
          message: this.$t('customCluster.customList.templateNameRequired'),
          trigger: 'blur',
        }],
        noticeTypeArr: [{
          required: true,
          message: this.$t('customCluster.customList.notificationTypeRequired'),
          trigger: 'change',
        }],
        language: [{ required: true, message: this.$t('customCluster.customList.languageRequired'), trigger: 'change' }],
        noticeUrl: [{
          required: true,
          message: this.$t('customCluster.customList.interfaceUrlRequired'),
          trigger: 'blur',
        }],
        weekday: [{
          required: true,
          message: this.$t('customCluster.customList.notificationCycleRequired'),
          trigger: 'change',
        }],
        pickerTime: [{
          required: true,
          message: this.$t('customCluster.customList.notificationTimeRequired'),
          trigger: 'change',
        }],
      },
      isEditCluster: false,
      functionInfoList: [],

      createScalingInSCFVisible: false,
      createScalingInSCFInfo: {
        workloadManager: '',
        region: '',
        roleName: '',
      },
      createScalingInSCFInfoRules: {
        roleName: [{
          required: true,
          message: this.$t('customCluster.customList.templateNameRequired'),
          trigger: 'blur',
        }],
        region: [{ required: true, message: this.$t('customCluster.customList.regionRequired'), trigger: 'change' }],
        workloadManager: [{
          required: true,
          message: this.$t('customCluster.customList.schedulerRequired'),
          trigger: 'change',
        }],
      },
      createScalingInSCFInfoLoading: false,
      regionData: regionList,
      projectPriceBlacklist: sessionStorage.getItem('projectPriceBlacklist').split(',') || [], // 项目价格黑名单
      hostRangeListForm: [],
      // 批量添加实例相关数据
      batchAddInstanceDialogVisible: false,
      batchAddInstanceLoading: false,
      batchAddInstanceCustomList: [], // 深拷贝的customList
      quantityArray: [], // 存储每个子集群对应的数量值
      statusArray: [], // 存储每个子集群的提交状态：null-未提交，true-成功，false-失败
      // IP预览相关数据
      batchPreviewDialogVisible: false,
      batchPreviewList: [], // IP预览列表
      currentPreviewSubcluster: null, // 当前预览的子集群信息
      batchAddInstancePassword: '',
      batchAddInstanceNextPassword: '',
      passwordRadio: false,
      isKeepImage: false,
    };
  },
  components: {
    addInstanceDialog,
    createCluster,
    ExamineAKSK,
    BatchIndex,
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.currentProject = currentProject;
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.getSubclusterList();
      }
    },
  },
  mounted() {
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.currentProject = currentProject;
    this.loginType = sessionStorage.getItem('loginType');
    this.getSubclusterList();
  },
  methods: {
    checkPasswordRadio(val) {
      if (val === true) {
        this.isKeepImage = true;
        this.batchAddInstancePassword = '';
        this.batchAddInstanceNextPassword = '';
      }
      if (val === false) {
        this.batchAddInstancePassword = '';
        this.batchAddInstanceNextPassword = '';
        this.isKeepImage = false;
      }
    },
    /**
     * 批量添加实例
     */
    openBatchAddInstanceDialog() {
      this.batchAddInstanceDialogVisible = true;
      this.passwordRadio = false;
      this.isKeepImage = false;
      this.$nextTick(() => {
        // 对customList进行深拷贝
        this.batchAddInstanceCustomList = JSON.parse(JSON.stringify(this.customList));
        this.batchAddInstancePassword = '';
        this.batchAddInstanceNextPassword = '';
        // 初始化quantityArray，为每个子集群设置默认数量0
        this.quantityArray = new Array(this.batchAddInstanceCustomList.length).fill(0);
        // 初始化statusArray，为每个子集群设置默认状态null（未提交）
        this.statusArray = new Array(this.batchAddInstanceCustomList.length).fill({
          status: null,
          message: '' });
      });
    },

    /**
     * 提交批量添加实例
     */
    submitBatchAddInstance(type) {
      // 检查是否有至少一个子集群设置了数量
      const hasQuantity = this.quantityArray.some(quantity => quantity > 0);
      if (!hasQuantity) {
        this.$message.warning(this.$t('customCluster.customList.atLeastOneQuantityRequired'));
        return;
      }

      // 判断密码是否为空
      if (this.isKeepImage === false && this.batchAddInstancePassword === '') {
        return Message.warning(this.$t('customCluster.addInstanceDialog.passwordRequired'));
      }

      // 判断密码是否一致且是否填写
      if (this.isKeepImage === false && (!this.batchAddInstancePassword || !this.batchAddInstanceNextPassword)) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordRequired'));
        return;
      }

      if (this.batchAddInstancePassword !== this.batchAddInstanceNextPassword) {
        this.$message.warning(this.$t('createNode.passwordNotMatch'));
        return;
      }

      // 判断密码是否符合规范
      if (this.batchAddInstancePassword !== '' && !this.validPassword(this.batchAddInstancePassword) && this.isKeepImage === false) {
        return false;
      }

      // console.log(type, 'typetypetype');
      // if (type) return;

      this.batchAddInstanceLoading = true;

      // 构建批量添加参数
      const batchParams = this.batchAddInstanceCustomList.map((item, index) => ({
        startIp: item.hostRangeList[0].startIp,
        subclusterId: item.id,
        instanceCount: this.quantityArray[index] || 0,
        password: this.batchAddInstancePassword,
        keepImageLogin: this.isKeepImage,
        dryRun: type === 'examine',
      })).filter(param => param.instanceCount > 0);

      // 初始化状态数组
      this.statusArray = new Array(this.batchAddInstanceCustomList.length).fill({
        status: null,
        message: '' });

      // 批量添加实例，跟踪每个子集群的提交状态
      Promise.all(batchParams.map((item) => {
        const originalIndex = this.batchAddInstanceCustomList.findIndex(subcluster => subcluster.id === item.subclusterId);

        // 设置loading状态
        if (originalIndex !== -1) {
          this.$set(this.statusArray, originalIndex, {
            status: 'loading',
            message: '' });
        }

        return extraPostRequest('/api/eda/common/subcluster/runInstances', item, { extra: type === 'examine' }).then(() => {
          // 提交成功，更新状态
          if (originalIndex !== -1) {
            this.$set(this.statusArray, originalIndex, {
              status: true,
              message: '' });
          }
          return { success: true, index: originalIndex };
        })
          .catch((error) => {
            // 提交失败，更新状态
            if (originalIndex !== -1) {
              this.$set(this.statusArray, originalIndex, {
                status: false,
                message: error });
            }
            return { success: false, index: originalIndex, error };
          });
      })).then((results) => {
        this.batchAddInstanceLoading = false;

        // 检查所有请求的结果
        const allSuccess = results.every(result => result.success);
        const hasFailure = results.some(result => !result.success);

        if (allSuccess) {
          if (type === 'examine') {
            Message.success(this.$t('customCluster.addInstanceDialog.canCreate'));
          } else {
            this.$message.success(this.$t('customCluster.customList.batchAddInstanceSuccess'));
            // this.batchAddInstanceDialogVisible = false;
            this.getSubclusterList();
          }
        } else if (hasFailure) {
          if (type === 'examine') {
            Message.warning('部分子集群实例无法创建!');
          } else {
            this.$message.warning(this.$t('customCluster.customList.batchAddInstancePartialSuccess'));
          }
          // 不关闭对话框，让用户看到哪些子集群提交失败
        }
      });
    },

    /**
     * 预览子集群可用的IP地址
     */
    previewSubclusterIp(subcluster) {
      this.currentPreviewSubcluster = subcluster;

      postRequest('/api/eda/common/subcluster/getAvailableIPList', {
        subclusterId: Number(subcluster.id),
      }).then((res) => {
        this.batchPreviewDialogVisible = true;
        this.batchPreviewList = res.relationList || [];
      })
        .catch((error) => {
          console.log(error, 'error');
          this.$message.error(this.$t('customCluster.customList.batchAddInstanceFailed'));
        });
    },

    /**
     * 获取最新的hostRangeListForm Ip段
     * */
    hostRangeListFormEmit(val) {
      this.hostRangeListForm = val;
    },

    /**
     * 新增云函数弹窗
     */
    createScalingInSCF() {
      this.createScalingInSCFInfo = {
        workloadManager: '',
        region: '',
        roleName: '',
      };
      this.createScalingInSCFVisible = true;
    },

    /**
     * 关闭云函数弹窗
     */
    closeCreateScalingInSCF() {
      this.createScalingInSCFInfoLoading = false;
      this.createScalingInSCFInfo = {
        workloadManager: '',
        region: '',
        roleName: '',
      };
      if (this.$refs.createScalingInSCFForm !== undefined) {
        this.$refs.createScalingInSCFForm.resetFields();
      }
      this.createScalingInSCFVisible = false;
    },

    /**
     * 创建云函数
     */
    submitCreateScalingInSCF() {
      this.$refs.createScalingInSCFForm.validate(async (valid) => {
        if (valid) {
          this.createScalingInSCFInfoLoading = true;

          postRequest('/api/eda/common/subcluster/createScalingInSCF', this.createScalingInSCFInfo)
            .then(() => {
              this.getFunctionInfoList();
              this.$message.success(this.$t('customCluster.customList.createSCFSuccess'));
              this.closeCreateScalingInSCF();
            })
            .catch(() => {
              this.createScalingInSCFInfoLoading = false;
            });
        }
      });
    },

    /**
     * 确定创建集群
     */
    doneFillIp() {
      this.affirm();
    },
    /**
     * 确认新增通知模板
     */
    async submitCreateNotification() {
      this.$refs.createNotificationDrawerForm.validate(async (valid) => {
        if (valid) {
          this.createNotificationDrawerFormLoading = true;
          try {
            const todayStart = dayjs().startOf('day');
            const startTime = dayjs(this.createNotificationDrawerForm.pickerTime[0]).diff(todayStart, 'second');
            const endTime = dayjs(this.createNotificationDrawerForm.pickerTime[1]).diff(todayStart, 'second');
            const noticeType = this.createNotificationDrawerForm.noticeTypeArr.length === 2
              ? 'ALL'
              : this.createNotificationDrawerForm.noticeTypeArr.join('');

            const params = {
              noticeName: this.createNotificationDrawerForm.noticeName,
              startTime,
              endTime,
              noticeType,
              weekday: this.createNotificationDrawerForm.weekday,
              noticeUrl: this.createNotificationDrawerForm.noticeUrl,
            };

            await postRequest('/api/eda/common/subcluster/createAlarmNotice', params).then(() => {
              this.createNotificationDrawerFormLoading = false;
              this.createNotificationDrawer = false;
              this.addAlarmPolicies();
            });
          } catch (error) {
            this.createNotificationDrawerFormLoading = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * 新增通知模板
     */
    createNotification() {
      this.createNotificationDrawerForm = {
        noticeName: '',
        noticeTypeArr: [],
        language: 'zh',
        noticeUrl: '',
        weekday: [],
        pickerTime: [
          new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
          new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59, 999),
        ],
      };
      this.getFunctionInfoList();
      this.createNotificationDrawer = true;
    },

    /**
     * 获取云函数列表
     */
    getFunctionInfoList() {
      getRequest('/api/eda/common/subcluster/describeSCFList').then((res) => {
        this.functionInfoList = res?.functionInfoList || [];
      });
    },

    /**
     * 关闭报警策略弹窗
     * 重置表单
     **/
    closeAlarmPoliciesDrawer(type) {
      if (type === 'alarmPoliciesDrawer') {
        if (this.$refs.alarmPoliciesDrawerForm !== undefined) {
          this.$refs.alarmPoliciesDrawerForm.resetFields();
        }
        this.alarmPoliciesDrawerForm = {
          policyName: '',
          remark: '',
          noticeIds: [],
          subclusterIds: [],
        };
        this.conditionList = JSON.parse(JSON.stringify(defalutConditionList));
        this.alarmPoliciesDrawerFormLoading = false;
      } else {
        if (this.$refs.createNotificationDrawerForm !== undefined) {
          this.$refs.createNotificationDrawerForm.resetFields();
        }
      }
    },

    /**
     * 创建报警策略
     **/
    async submitAlarmPolicies() {
      this.$refs.alarmPoliciesDrawerForm.validate(async (valid) => {
        if (valid) {
          try {
            this.alarmPoliciesDrawerFormLoading = true;
            const params = {
              ...this.alarmPoliciesDrawerForm,
              // 报警条件
              conditions: this.conditionList.map(item => ({
                ...item,
                value: String(item.value),
              })),
            };

            await postRequest('/api/eda/common/subcluster/createAlarmPolicy', params);
            this.$message.success(this.$t('customCluster.customList.createAlarmPolicySuccess'));
            this.alarmPoliciesDrawerFormLoading = false;
            this.alarmPoliciesDrawer = false;
            await this.openAlarmPoliciesDialog();
          } catch (error) {
            this.alarmPoliciesDrawerFormLoading = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 新增报警策略
    async addAlarmPolicies() {
      this.conditionList = JSON.parse(JSON.stringify(defalutConditionList));
      this.alarmPoliciesDrawer = true;
      this.alarmPoliciesDrawerFormLoading = true;

      try {
        // 获取基础指标列表
        if (this.describeBaseMetricsList.length === 0) {
          const metricsRes = await postRequest('/api/eda/common/tencentcloud/describeBaseMetrics');
          this.describeBaseMetricsList = metricsRes?.list || [];
        }

        // 获取告警通知列表
        const noticesRes = await postRequest('/api/eda/common/subcluster/describeAlarmNotices', {
          offset: 0,
          limit: 20,
        });
        this.describeAlarmNoticesList = noticesRes?.list || [];
        this.alarmPoliciesDrawerFormLoading = false;
      } catch (error) {
        this.alarmPoliciesDrawer = false;
        this.alarmPoliciesDrawerFormLoading = false;
        // 这里可以添加错误提示，具体实现取决于项目使用的UI组件库
      }
    },

    // 查询格式化初始化脚本
    inputUserdata(value) {
      this.userdataTemplateList = this.defaultUserdataTemplateList.filter(item => item.name.includes(value));
    },

    // 导出预览IP
    exportPreviewIp(item) {
      const result = item.map(item => ({
        name: item.hostname,
        ip: item.ip,
      }));
      exportData(result, this.$t('customCluster.customList.previewIp'));
    },

    /**
     * 打开报警策略弹窗
     * 获取报警策略
     */
    async openAlarmPoliciesDialog() {
      try {
        this.describeAlarmPoliciesLoading = true;
        this.describeAlarmPoliciesVisible = true;
        const subclusterIds = this.customList.map(item => item.id);

        const res = await postRequest('/api/eda/common/subcluster/describeAlarmPolicies', {
          subclusterIds,
          offset: 0,
          limit: 20,
        });

        this.describeAlarmPoliciesList = res?.list || [];

        this.alarmPoliciesForm = (res?.selectedList || []).map(item => ({
          ...item,
          deleteShow: false,
        })) || [
          {
            policyId: '',
            subclusterIds: [],
            deleteShow: true,
          },
        ];
      } catch (error) {
        console.error('获取报警策略失败:', error);
      } finally {
        this.describeAlarmPoliciesLoading = false;
      }
    },

    /**
     * 增加报警策略
     */
    addAlarmPoliciesNumber() {
      this.alarmPoliciesForm.push({
        policyId: '',
        subclusterIds: [],
        deleteShow: true,
      });
    },

    /**
     * 删除报警策略
     * */
    deleteAlarmPolicies(index) {
      this.alarmPoliciesForm.splice(index, 1);
    },

    /**
     * 完成报警策略弹窗
     */
    doneDescribeAlarmPolicies() {
      if (this.alarmPoliciesForm.length === 0) return this.$message.warning(this.$t('customCluster.customList.selectAlarmPolicy'));
      this.doneDescribeAlarmPoliciesLoding = true;
      postRequest('/api/eda/common/subcluster/bindAlarmPolicy', { list: this.alarmPoliciesForm })
        .then(() => {
          this.$message.success(this.$t('customCluster.customList.bindAlarmPolicySuccess'));
          this.describeAlarmPoliciesVisible = false;
          this.doneDescribeAlarmPoliciesLoding = false;
        })
        .catch(() => {
          this.doneDescribeAlarmPoliciesLoding = false;
        });
    },

    /**
     * 打开创建集群弹窗
     */
    openPwDialog(data) {
      this.previewDialogVisible = true;
      this.previewList = data;
    },

    /**
     * 获取自定义集群数据
     */
    getSubclusterList(val) {
      if (val !== 'edit') {
        this.projectInstanceListLoading = true;
      }
      const offset = this.limit * (this.currentPage - 1);
      const data = {
        offset,
        limit: this.limit,
      };
      postRequest('/api/eda/common/subcluster/getSubclusterList', data)
        .then((res) => {
          this.customList = res?.subclusterList || [];
          this.total = res?.totalCount || 0;
          this.projectInstanceListLoading = false;
        })
        .catch(() => {
          this.projectInstanceListLoading = false;
        });
    },

    /**
     * 导出数据
     */
    checkRadio(val) {
      if (val === true) {
        this.$refs.batchIndex.getSubclusterInstances(Number(this.exportId));
        this.isKeepImage = true;
      }
      if (val === false) {
        this.password = '';
        this.nextPassword = '';
        this.isKeepImage = false;
      }
    },

    /**
     * 获取创建自定义集群配置信息
     */
    checkPrice(data) {
      this.unitPrice = '-';
      this.unitPriceDiscount = '-';
      this.instanceChargeType = data.instanceChargeType;

      if (data.instanceService === 'thpc') {
        this.unitPrice = data.thpcInstanceTypePrice.UnitPrice;
        this.unitPriceDiscount = data.thpcInstanceTypePrice.UnitPriceDiscount;
        return;
      }

      if (this.isEditCluster) {
        return;
      }
      if (data.Zone === '') {
        return;
      }
      if (data.instanceType === '') {
        return;
      }
      if (data.diskSize === '') {
        return;
      }
      if (data.diskType === '') {
        return;
      }
      if (data.imageId === '') {
        return;
      }
      if (data.instanceDescription === '') {
        return;
      }
      if (data.subnetId === '') {
        return;
      }

      this.createLoading = true;
      postRequest('/api/eda/common/tencentcloud/inquiryInstancePrice', {
        DiskSize: data.diskSize / 1,
        DiskType: data.diskType,
        ImageId: data.imageId,
        InstanceChargeType: data.instanceChargeType,
        InstanceType: data.instanceDescription,
        Region: data.region,
        Zone: data.zone,
      })
        .then((res) => {
          this.unitPrice = res.unitPrice;
          this.unitPriceDiscount = res.unitPriceDiscount;
          this.createLoading = false;
        })
        .catch(() => {
          this.createLoading = false;
        });
    },

    /**
     * 销毁子集群
     */
    deleteSubcluster(val) {
      this.$confirm(this.$t('customCluster.customList.deleteSubclusterConfirm'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      })
        .then(() => {
          const data = {
            subclusterId: val,
          };
          postRequest('/api/eda/common/subcluster/deleteSubcluster', data).then(() => {
            this.$message.success(this.$t('customCluster.customList.deleteSuccess'));
            this.getSubclusterList();
          });
        })
        .catch(() => {
        });
    },

    /**
     * 翻页
     */
    handleSizeChange(limit) {
      if (limit === this.limit) {
        return;
      }
      this.currentPage = 1;
      this.limit = limit;
      this.getSubclusterList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getSubclusterList();
    },

    /**
     * 添加实例
     */
    showAddInstanceDialog(id) {
      this.subclusterId = id;
      this.$refs.addInstanceDialog.dialogVisible = true;
    },

    /**
     * 跳转查看详情
     */
    toDetail(row) {
      this.$router.push({ path: 'customDetail', query: { id: row.id, name: row.name } });
    },

    /**
     * 跳转监控详情
     */
    toMonitor(row) {
      this.$router.push({ path: 'customDetail', query: { id: row.id, name: row.name, activeName: 'monitor' } });
    },

    /**
     * 跳转腾讯云查看详情
     */
    open(type, val) {
      switch (type) {
        case 'vpc':
          window.open(`https://console.cloud.tencent.com/vpc/vpc/detail?rid=${regionMap.get(val.region)}&id=${val.vpc_id}`);
          break;
        case 'subnet':
          window.open(`https://console.cloud.tencent.com/vpc/subnet/detail?rid=${regionMap.get(val.region)}&id=${val.subnet_id}`);
          break;
        case 'textLink':
          window.open(val);
      }
    },

    /**
     * 转换地区名称
     */
    zoneName(val) {
      if (val.region && val.zone) {
        const zoneList = val.zone.split('-');
        return `${this.regionNameMap.get(val.region)}${zoneList[zoneList.length - 1]}${this.$t('customCluster.customList.zone')}`;
      }
      return '-';
    },

    /**
     * 是否显示弹窗
     */
    showLoading(val) {
      this.isCreating = val;
    },

    /**
     * 创建集群
     */
    createClusterDialog(type, id) {
      if (type === 'create') {
        this.isEditCluster = false;
        this.dialogClusterVisible = true;
        this.editClusterInfo = false;
        this.$nextTick(() => {
          this.$refs.createCluster.getRegions();
          this.$refs.createCluster.changeIsEditCluster();
        });
      } else {
        this.isEditCluster = type === 'edit';
        this.editClusterInfo = type === 'edit';
        this.dialogClusterVisible = true;
        this.$nextTick(() => {
          this.$refs.createCluster.editCluster(id, type);
        });
      }
    },

    /**
     * 检查是否录入子账号
     */
    checkProjectTencentAccountExist() {
      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/eda/checkProjectTencentAccountExist', {
          isOwner: this.currentProject.isOwner === 1,
        })
          .then(() => {
            this.createClusterDialog('create');
          })
          .catch(() => {
            // 管理员isOwner = 1
            if (this.currentProject.isOwner === 1) {
              this.examineAKSKVisible = true;
            }
          });
      } else {
        this.createClusterDialog('create');
      }
    },

    /**
     * 取消录入aksk弹窗
     */
    examineAKSKVisibleFalse() {
      this.examineAKSKVisible = false;
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.stepLocation = 0;
      this.dialogClusterVisible = false;
    },

    /**
     * 清除数据
     */
    clearFromData() {
      this.unitPrice = '-';
      this.unitPriceDiscount = '-';
      this.$refs.createCluster.closeForm();
    },

    stepLocationIndex(type) {
      if (type) {
        this.stepLocation = this.stepLocation + 1;
      } else {
        this.stepLocation = this.stepLocation - 1;
      }
      this.$refs.createCluster.createHostRangeList(this.stepLocation).catch(() => {
        this.stepLocation = this.stepLocation - 1;
        console.log(this.stepLocation, 'this.stepLocation');
      });
    },

    /**
     * 确定创建集群
     */
    affirm() {
      this.createLoading = true;
      try {
        this.$refs.createCluster
          .clickAccomplish()
          .then(() => {
            this.createLoading = false;
            this.$refs.createCluster.closeForm();
            this.stepLocation = 0;
          })
          .catch(() => {
            this.createLoading = false;
          });
      } catch (e) {
        this.createLoading = false;
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    selectable(row) {
      return row.instance_num !== 0;
    },

    showRenameDialog(val) {
      this.renameVisible = true;
      this.clusterName = val.name;
      this.oldClusterName = val.name;
      this.currentRowId = val.id;
      this.$nextTick(() => {
        this.$refs.editInput.focus();
      });
    },

    /**
     * 确定编辑集群
     */
    modify() {
      if (this.clusterName.length === 0) {
        return this.$message.warning(this.$t('customCluster.customList.nameCannotBeEmpty'));
      }
      if (this.clusterName === this.oldClusterName) {
        return this.$message.warning(this.$t('customCluster.customList.nameSameAsOld'));
      }
      this.renameVisible = false;
      postRequest('/api/eda/common/subcluster/modifySubclusterConfig', {
        subclusterId: this.currentRowId,
        name: this.clusterName,
      }).then(() => {
        this.$message.success(this.$t('customCluster.customList.modifySuccess'));
        this.getSubclusterList();
      });
    },

    /**
     * 打开导出弹窗
     */
    openExportDialog(type) {
      this.exportId = type.id;
      this.batchIndex = [];
      this.radio = false;
      this.exportDialogVisible = true;
    },

    filterSubclusterInstances(batchIndex) {
      this.batchIndex = batchIndex;
    },

    /**
     * 导出数据
     */
    exportBatch() {
      const arr = [];
      this.batchIndex.forEach((item) => {
        arr.push(item[0]);
      });
      const data = {
        subclusterId: [Number(this.exportId)],
        batchIndex: arr,
      };
      postRequest('/api/eda/common/subcluster/exportHostname', data).then((res) => {
        this.exportDialogVisible = false;
        if (!res.relationList || res.relationList.length === 0) {
          return this.$message.warning(this.$t('customCluster.customList.noData'));
        }
        const result = res.relationList.map(item => ({
          hostname: item.hostname,
          ip: item.ip,
          region: item.region,
          instance_id: item.instance_id,
        }));
        exportData(result, 'data');
      });
    },

    /**
     * 导出表格
     */
    exportToExcel(type) {
      const subclusterIdList = [];
      if (type === 'batch') {
        this.multipleSelection.forEach((item) => {
          subclusterIdList.push(item.id);
        });
      } else {
        subclusterIdList.push(type.id);
      }
      postRequest('/api/eda/common/subcluster/exportHostname', {
        subclusterId: subclusterIdList,
        batchIndex: [],
      }).then((res) => {
        if (!res.relationList || res.relationList.length === 0) {
          return this.$message.warning(this.$t('customCluster.customList.noData'));
        }
        const result = res.relationList.map(item => ({
          hostname: item.hostname,
          ip: item.ip,
          region: item.region,
          instance_id: item.instance_id,
        }));
        exportData(result, 'data');
      });
    },
    /**
     * 编辑集群
     */
    editCluster(type, id) {
      this.createClusterDialog(type, id);
    },

    /**
     * 设置自定义子集群实例的初始化命令
     */
    setSubclusterInitCommandShow(data) {
      this.subclusterId = data.id;
      this.subclusterName = data.name;
      this.getSubclusterInitTemplate();
      this.getSubclusterInitCommand();
    },

    /**
     * 获取初始化脚本 模板
     */
    getSubclusterInitTemplate() {
      postRequest('/api/eda/common/subcluster/getSubclusterInitCommandTemplates', {
        subclusterId: this.subclusterId,
      }).then((res) => {
        const list = res.content.map((item) => {
          let baseValue = Base64.decode(item.value);
          item.system_variable.map((part) => {
            const regex = new RegExp(`\\(\\(${part}\\)\\)`, 'g');
            baseValue = baseValue.replace(regex, res.systemVariable[part]);
          });

          item.value = baseValue;
          return item;
        });

        this.systemVariable = res.systemVariable;
        this.userdataTemplateList = list;
        this.defaultUserdataTemplateList = list;
      });
    },

    /**
     * 拼接数据
     */
    spliceSubclusterInit(data) {
      const defaultData = '#!/bin/bash';
      if (this.subclusterInit.indexOf(defaultData) === -1) {
        this.subclusterInit = this.subclusterInit + defaultData;
      }
      if (data.variable.length === 0) {
        this.subclusterInit = this.subclusterInit + data.value;
      } else {
        this.defaultSpliceSubclusterData = data.variable.map(item => ({
          value: '',
          variable: item,
          placeholder: this.$t('customCluster.customList.inputPlaceholder', { item }),
        }));
        this.subclusterInitValue = data.value;
        this.variableDialogFormVisible = true;
      }
    },

    /**
     * 格式化数据并拼接
     */
    doneSubclusterVariable() {
      let baseValue = this.subclusterInitValue;
      this.defaultSpliceSubclusterData.map((part) => {
        this.systemVariable[part.variable] = part.value;
        const regex = new RegExp(`\\(\\(${part.variable}\\)\\)`, 'g');
        baseValue = baseValue.replace(regex, this.systemVariable[part.variable]);
      });

      this.subclusterInit = this.subclusterInit + baseValue;
      this.variableDialogFormVisible = false;
    },

    /**
     * 获取初始化脚本
     */
    getSubclusterInitCommand() {
      postRequest('/api/eda/common/subcluster/getSubclusterInitCommand', {
        subclusterId: this.subclusterId,
      }).then((res) => {
        this.subclusterInitCommandVisible = true;
        this.subclusterInit = Base64.decode(res.userData) || '';
      });
    },

    /**
     * 保存初始化脚本
     */
    subclusterInitCommandModify() {
      const defaultData = '#!/bin/bash';
      if (!this.base64Radio && this.subclusterInit.indexOf(defaultData) === -1) return this.$message.error(this.$t('customCluster.customList.initScriptError'));

      postRequest('/api/eda/common/subcluster/setSubclusterInitCommand', {
        subclusterId: this.subclusterId,
        userData: this.base64Radio ? this.subclusterInit : Base64.encode(this.subclusterInit),
      }).then(() => {
        this.$message.success(this.$t('customCluster.customList.saveInitScriptSuccess'));
        this.subclusterInitCommandVisible = false;
      });
    },

    /**
     * 子集群超线程修改
     */
    setTopology(id, type) {
      postRequest('/api/eda/common/subcluster/setTopology', {
        subclusterId: id,
        Topology: !type,
      }).then(() => {
        this.$message.success(this.$t('customCluster.customList.topologyModifySuccess'));
        this.getSubclusterList();
      });
    },
    /**
     * 校验密码
     */
    validPassword(pwd) {
      if (pwd.length < 12 || pwd.length > 30) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordLengthInvalid'));
        return false;
      }
      if (pwd.includes(' ')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordContainsSpace'));
        return false;
      }
      if (this.batchAddInstancePassword !== this.batchAddInstanceNextPassword) {
        Message.warning(this.$t('customCluster.addInstanceDialog.passwordMismatch'));
        return false;
      }

      if (pwd.startsWith('/')) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordStartsWithSlash'));
        return false;
      }

      // 只能含有数字,大小写字母及_@ 其必须包含 一个小写字母 或 一个大写字母 或 数字 或 ()`~!@#$%^&*-+=_|{}[]:;'<>,.?/
      let hasLower = 0;
      let hasUpper = 0;
      let hasDigit = 0;
      let hasSpecial = 0;
      for (let i = 0; i < pwd.length; i++) {
        const char = pwd[i];
        if (char >= 'a' && char <= 'z') {
          hasLower = 1;
        } else if (char >= 'A' && char <= 'Z') {
          hasUpper = 1;
        } else if (char >= '0' && char <= '9') {
          hasDigit = 1;
        } else if ('()`~!@#$%^&*-+=_|{}[]:;\'<>,.?/'.includes(char)) {
          hasSpecial = 1;
        } else {
          this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordInvalid'));
          return false;
        }
      }
      if (hasLower + hasUpper + hasDigit + hasSpecial < 3) {
        this.$message.warning(this.$t('customCluster.addInstanceDialog.passwordComplexity'));
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.variableTitle {
  background: #efefef;
  line-height: 30px;
  padding-left: 20px;
}

.userDataTemplate-cls {
  width: 230px;
  border: 1px solid #dcdfe6;
  border-radius: 5.5px;
  font-size: 14px;
  height: 395px;
  overflow: auto;

  div {
    padding: 4px 8px;
    box-sizing: border-box;
    cursor: pointer;
  }

  div:hover {
    span {
      color: #2a83d4;
    }
  }
}

.create-price__span {
  margin-right: 10px;
}

.unitPrice_cls {
  font-size: 12px;
  text-decoration: line-through;
  margin-right: 10px;
}

.previewDialog_main--div {
  max-height: 500px;
  overflow: auto;
}

.custom-container {
  height: 100%;

  .no-data {
    height: 100%;
    display: flex;
    justify-content: center;
    background: #fff;
  }

  .custom-table__content {
    height: 100%;

    .custom-table {
      height: calc(100% - 128px);

      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 48px);
        overflow-y: auto;
      }
    }

    .pagination {
      padding: 20px 10px;
      background: #fff;
      text-align: right;

      ::v-deep .el-pagination__total {
        float: left;
      }
    }
  }

  .el-icon-edit {
    padding: 0;
  }

  .white-norwrap {
    white-space: nowrap;
    line-height: 32px;
  }

  .text-not-wrap-ellipsis {
    display: inline-block;
    width: 100px;
    word-break: keep-all; // 只能在半角空格或连字符处换行
    white-space: nowrap; // 文本不换行，除非<br>
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 超出部分显示省略号
    -o-text-overflow: ellipsis;
  }
}

.form-title {
  margin-left: 12px;
  margin-bottom: 16px;
}

.interfaceCallback_div_cls {
  background: #f2f4f8;
  padding: 20px 0;

  p {
    color: #00000080;
  }
}

/* 批量添加实例弹窗样式 */
.batch-add-instance-container {
  height: 450px;
  //overflow-y: auto;
}

.batch-add-header {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #ebeef5;
  font-weight: 600;
  background-color: #f5f7fa;
}

.batch-add-list {
  width: 672px;
  height: 400px;
  overflow-y: auto;
}

.batch-add-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.batch-add-item:hover {
  background-color: #f8f9fa;
}

.header-item, .item-content {
  width: 120px;
  padding: 0 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-item.subcluster-name, .item-content.subcluster-name {
  width: 200px;
}

.header-item.status, .item-content.status {
  width: 100px;
  text-align: center;
  justify-content: center;
}

.success-icon {
  color: #67c23a;
  font-size: 18px;
}

.error-icon {
  color: #f56c6c;
  font-size: 18px;
}

.loading-icon {
  color: #409eff;
  font-size: 18px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.header-item.instance-type, .item-content.instance-type {
  width: 200px;
  justify-content: flex-start;
}

.header-item.quantity, .item-content.quantity {
  width: 130px;
  text-align: center;
  justify-content: center;
}

.header-item.operation, .item-content.operation {
  width: 120px;
  text-align: center;
  justify-content: center;
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}

.batch-preview-dialog {
  max-height: 400px;
  overflow-y: auto;
}
</style>
